// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'rounded-medium';

export const Component = () => (
  <g fill='none' stroke='transparent' strokeLinecap='round' strokeLinejoin='round'>
    <path fill='#D0E0F7' d='M1 8.5C1 4.015 4.015 1 8.5 1H19v18H1V8.5Z' />
    <path
      fill='#4185DE'
      d='M0 8.5C0 3.456 3.456 0 8.5 0H19v2H8.5C5.015 2 2 5.015 2 8.5H0ZM19 19H1h18ZM0 19V8.5C0 3.456 3.456 0 8.5 0v2C5.015 2 2 5.015 2 8.5V19H0ZM19 1v18V1Z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
